module.exports = __webpack_public_path__ + "static/media/ic-category-review-off.7aacba66.svg";